<template>
  <div class="original-bill">
    <div class="header">
      <el-input class="query" v-model.trim="orderNo" placeholder="请输入交易单号" clearable @keyup.native.enter="getBillList(1)" @clear="getBillList(1)"></el-input>
      <el-button type="primary" @click="getBillList(1)">查询</el-button>
    </div>
    <Table :data="billList" :columns="columns" :pages="pages"></Table>
  </div>
</template>
<script>
import BillService from "@/apis/BillService";
import Table from "@/components/new-table.vue";
import { BillOrderType, BillStatementColor, BillStatementState, PayMethods, PayWay } from "@/service/enum";
export default {
  components: { Table },
  data() {
    return {
      orderNo: "",
      merName: "",
      billList: [],
      columns: [
        { label: "订单号", prop: "orderNo", "min-width": "150px" },
        { label: "订单类型", prop: "orderTypeLabel", "min-width": "80px" },
        { label: "业务类型", prop: "payMethodLabel", "min-width": "100px" },
        { label: "支付方式", prop: "payTheWayLabel", "min-width": "110px" },
        {
          label: "对账状态", "min-width": "80px", render: (h, { row }) => {
            return <span style={{ color: row.billStatusColor }}>{row.billStatusLabel}</span>
          },
        },
        { label: "订单金额", prop: "orderMoney", "min-width": "80px" },
        { label: "服务费", prop: "serviceFee", "min-width": "80px" },
        { label: "实际对账金额", prop: "merchantBillMoney", "min-width": "110px" },
        { label: "应对账金额", prop: "merchantMoney", "min-width": "100px" },
        { label: "对账时间", prop: "billDateTime", "min-width": "150px" },
      ],
      pages: {
        props: {
          total: 0,
          "page-size": 20,
          "current-page": 1,
        },
        on: {
          "current-change": this.currentChange,
          "size-change": this.sizesChange
        },
      },
    }
  },
  mounted() {
    this.getBillList();
  },
  methods: {
    getBillList(pageIndex) {
      const page = pageIndex || this.pages.props["current-page"];
      const pageSize = this.pages.props["page-size"];
      const params = {
        page,
        pageSize,
        statisDetilId: this.$route.query.id || "",
        orderNo: this.orderNo,
      }
      BillService.getCompStatementList(params).then(res => {
        this.billList = res.data.map(i => {
          i.orderTypeLabel = BillOrderType[i.orderType];
          i.billStatusLabel = BillStatementState[i.billStatus];
          i.billStatusColor = BillStatementColor[i.billStatus];
          i.payMethodLabel = i.payMethod ? PayMethods[i.payMethod] : "-";
          i.payTheWayLabel = i.payTheWay ? PayWay[i.payTheWay] : "-";
          i.serviceFee = (i.platformBillMoney + i.serviceCharge).toFixed(2) //服务费=平台的结算金额+手续费
          return i;
        });
        this.pages.props.total = res.dataCount;
      });
    },
    sizesChange(val) {
      this.pages.props["page-size"] = val;
      this.getBillList(1);
    },
    currentChange(page) {
      this.pages.props["current-page"] = page;
      this.getBillList();
    },
  }
}
</script>

<style lang="scss" scoped>
.original-bill {
  display: flex;
  flex-direction: column;
}
.header {
  margin-bottom: 20px;
}
.query {
  width: 200px;
  margin-right: 20px;
  vertical-align: middle;
}
.state {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .state-dot {
    width: 5px;
    margin-right: 5px;
    height: 5px;
    border-radius: 50%;
  }
}
</style>